import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { SettingsIcon, CalendarIcon, DollarSignIcon, MapIcon, ShieldAlertIcon } from 'lucide-react';
export function SystemConfiguration() {
  const [activeTab, setActiveTab] = useState<'ban' | 'tariff' | 'geo'>('ban');
  // Mock Data
  const banCalendar = [{
    resource: 'Honey',
    startDate: '2024-06-01',
    endDate: '2024-07-31',
    status: 'Active',
    approvedBy: 'Admin'
  }, {
    resource: 'Fish',
    startDate: '2024-05-15',
    endDate: '2024-08-15',
    status: 'Pending Approval',
    approvedBy: '-'
  }, {
    resource: 'Wood',
    startDate: '2024-01-01',
    endDate: '2024-12-31',
    status: 'Active',
    approvedBy: 'Admin'
  }];
  const tariffTable = [{
    resource: 'Honey',
    unit: 'Kg',
    baseFee: '50',
    tax: '15%',
    status: 'Active'
  }, {
    resource: 'Fish',
    unit: 'Kg',
    baseFee: '20',
    tax: '10%',
    status: 'Active'
  }, {
    resource: 'Golpata',
    unit: 'Maund',
    baseFee: '100',
    tax: '15%',
    status: 'Pending Approval'
  }];
  const geoHierarchy = [{
    level: 'Division',
    name: 'Khulna',
    parent: '-'
  }, {
    level: 'Range',
    name: 'Chandpai',
    parent: 'Khulna'
  }, {
    level: 'Station',
    name: 'Karamjal',
    parent: 'Chandpai'
  }, {
    level: 'Compartment',
    name: 'C-12',
    parent: 'Karamjal'
  }];
  const banColumns = [{
    key: 'resource',
    label: 'Resource'
  }, {
    key: 'startDate',
    label: 'Start Date'
  }, {
    key: 'endDate',
    label: 'End Date'
  }, {
    key: 'status',
    label: 'Status',
    render: (val: string) => <span className={`px-2 py-1 rounded-full text-xs font-medium ${val === 'Active' ? 'bg-green-100 text-green-800' : 'bg-orange-100 text-orange-800'}`} data-id="element-2058">
          {val}
        </span>
  }, {
    key: 'approvedBy',
    label: 'Approved By'
  }];
  const tariffColumns = [{
    key: 'resource',
    label: 'Resource'
  }, {
    key: 'unit',
    label: 'Unit'
  }, {
    key: 'baseFee',
    label: 'Base Fee (৳)'
  }, {
    key: 'tax',
    label: 'Tax (%)'
  }, {
    key: 'status',
    label: 'Status',
    render: (val: string) => <span className={`px-2 py-1 rounded-full text-xs font-medium ${val === 'Active' ? 'bg-green-100 text-green-800' : 'bg-orange-100 text-orange-800'}`} data-id="element-2059">
          {val}
        </span>
  }];
  const geoColumns = [{
    key: 'level',
    label: 'Level'
  }, {
    key: 'name',
    label: 'Name'
  }, {
    key: 'parent',
    label: 'Parent Node'
  }];
  return <div className="space-y-6" data-id="element-2060">
      <div data-id="element-2061">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2" data-id="element-2062">
          <SettingsIcon className="text-[#1B5E20]" data-id="element-2063" />
          System Configuration
        </h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-2064">
          Global settings, ban periods, tariffs, and geographical hierarchy
        </p>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 flex items-start gap-3" data-id="element-2065">
        <ShieldAlertIcon className="text-blue-600 mt-0.5" size={20} data-id="element-2066" />
        <div data-id="element-2067">
          <h4 className="font-semibold text-blue-900" data-id="element-2068">
            Maker-Checker Policy Active
          </h4>
          <p className="text-sm text-blue-700 mt-1" data-id="element-2069">
            Any changes to Ban Dates or Tariffs require Admin/Financial Admin
            approval before taking effect across stations.
          </p>
        </div>
      </div>

      <div className="border-b border-gray-200" data-id="element-2070">
        <div className="flex gap-4" data-id="element-2071">
          <button onClick={() => setActiveTab('ban')} className={`flex items-center gap-2 px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'ban' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-2072">
            <CalendarIcon size={16} data-id="element-2073" />
            Ban Calendar
          </button>
          <button onClick={() => setActiveTab('tariff')} className={`flex items-center gap-2 px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'tariff' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-2074">
            <DollarSignIcon size={16} data-id="element-2075" />
            Tariff Master
          </button>
          <button onClick={() => setActiveTab('geo')} className={`flex items-center gap-2 px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'geo' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-2076">
            <MapIcon size={16} data-id="element-2077" />
            Geo Hierarchy
          </button>
        </div>
      </div>

      {activeTab === 'ban' && <div className="space-y-4" data-id="element-2078">
          <div className="flex justify-end" data-id="element-2079">
            <button className="px-4 py-2 bg-[#1B5E20] text-white rounded-lg hover:bg-[#2E7D32] text-sm font-medium" data-id="element-2080">
              + Propose Ban Update
            </button>
          </div>
          <DataTable columns={banColumns} data={banCalendar} searchPlaceholder="Search resources..." data-id="element-2081" />
        </div>}

      {activeTab === 'tariff' && <div className="space-y-4" data-id="element-2082">
          <div className="flex justify-end" data-id="element-2083">
            <button className="px-4 py-2 bg-[#1B5E20] text-white rounded-lg hover:bg-[#2E7D32] text-sm font-medium" data-id="element-2084">
              + Propose Tariff Change
            </button>
          </div>
          <DataTable columns={tariffColumns} data={tariffTable} searchPlaceholder="Search resources..." data-id="element-2085" />
        </div>}

      {activeTab === 'geo' && <div className="space-y-4" data-id="element-2086">
          <div className="flex justify-end" data-id="element-2087">
            <button className="px-4 py-2 bg-[#1B5E20] text-white rounded-lg hover:bg-[#2E7D32] text-sm font-medium" data-id="element-2088">
              + Add Node
            </button>
          </div>
          <DataTable columns={geoColumns} data={geoHierarchy} searchPlaceholder="Search locations..." data-id="element-2089" />
        </div>}
    </div>;
}